import { render } from "./ShowTicketTeleponDouble.vue?vue&type=template&id=46b5e4bf"
import script from "./ShowTicketTeleponDouble.vue?vue&type=script&lang=js"
export * from "./ShowTicketTeleponDouble.vue?vue&type=script&lang=js"

import "./ShowTicketTeleponDouble.vue?vue&type=style&index=0&id=46b5e4bf&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__